module.exports = __webpack_public_path__ + "static/media/gg-logo.c32a0a53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gg-logo.png
// module id = 1935
// module chunks = 0